var isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));

export function attachCartPopupEvents() {
  $('.js-cart-icon').on('click', cartIconClickListener)

  // mouseenter is not worked in mozilla
  $('.js-cart-icon').hover(cartIconHoverListener, cartIconUnHoverListener);

  $('body').on('click', bodyClickListener)
}

function cartIconClickListener(e) {
  if (!$(this).hasClass('is-empty') && !isTouch) {
    if (isBigDevices()) {
      if ($(this).hasClass('js-redirect')) {
        redirectToCartPage();
      } else {
        $(this).addClass('js-redirect');
        $('.js-cart-popup').addClass('open');
      }
    }
  } else if (!$(this).hasClass('is-empty') && isTouch) {
    $(this).removeClass('hovered');
    redirectToCartPage();
  }
}

function cartIconHoverListener(e) {
  if (!isTouch) {
    if (!$(this).hasClass('is-empty') && !$('body').hasClass('template-cart')) {
      if (isBigDevices()) {
        $(this).addClass('js-redirect hovered');
        $('.js-cart-popup').addClass('open');
      }
    } else {
      $(this).removeClass('js-redirect hovered');
    }
  }
}

function cartIconUnHoverListener(e) {
  if (!$(this).hasClass('is-empty') && !isTouch) {
    if (isBigDevices()) {
      $(this).addClass('js-redirect');
      $(this).removeClass('open');
    }
  }
}

function bodyClickListener(e) {
  if (!e.target.closest('.js-cart-icon')) {
    $('.js-cart-popup').removeClass('open');
    $('.js-cart-icon').removeClass('js-redirect');
  }
}

function isBigDevices() {
  if ($(window).width() > 1024) {
    return true;
  }
}

function redirectToCartPage() {
  window.location = '/cart';
}
